import PropTypes from 'prop-types';
import { STEPS } from '../utils/storage';
import Emote from './Emote';

export default function Rating({ score, userData, submitVote }) {
	const selection = userData.selection;
	const classes = ['blog-feedback__rating'];
	userData.step === STEPS.QUESTION && classes.push('blog-feedback__rating--open');

	return (
		<div className={classes.join(' ')}>
			{Object.keys(score)
				.reverse()
				.map((key) => {
					return <Emote key={key} selection={selection} count={score[key]} submitVote={submitVote} value={key} />;
				})}
		</div>
	);
}

Rating.propTypes = {
	score: PropTypes.object,
	userData: PropTypes.object,
	submitVote: PropTypes.func,
};
